export default __webpack_public_path__ + "static/media/happy.713991ca.jpg";